import './ResetConfirm.scss';
import React, { useState, useEffect, useRef } from 'react';
import * as yup from 'yup';
import { Formik, Form } from 'formik';
import { Button, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import appapi from '../../../api/apiClient';
import { showmessage } from '../../../utils/toastr';
import { useParams, useNavigate } from 'react-router-dom';
import { buttonStyle1 } from '../../../utils/commonStyle';
// import vitarakatextlogo from '../../../assets/images/vitarakatextlogo.svg';
// import vitarakalogoMobile from '../../../assets/images/vitarakalogoMobile.svg';
import { useDispatch } from 'react-redux';
import { setLoading } from '../../../redux/features/appSlice';
import FormTextField from '../../../components/FormTextField';
import Logo from '../../../assets/images/ze-logo.svg';

/**
 * Validation Schema for register
 */
const validationSchema = yup.object({
  password: yup
    .string('Enter your Password')
    // .min(8, 'Password must be minimum of 6 characters')
    // .max(12, 'Password must be maximum of 12 characters')
    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/, 'Enter a password of minimum 8 and maximum 20 characters with a combination of capital letters, small letters, symbols, and numbers.')
    .required('Password is requried')
    .trim(),
  reConfirmPassword: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Password must match')
    .required('Retype Password is requried')
    .trim(),
});

export default function ResetConfirm() {
  const paramsFromUrl = useParams();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const formRef = useRef();

  const theme = useTheme();

  const isMobile = useMediaQuery('(max-width:1000px)');

  const [visibility1, setVisibility1] = useState(false);
  const [visibility2, setVisibility2] = useState(false);
  const [data, setData] = useState({
    password: '',
    reConfirmPassword: '',
  });

  const [message, setMessage] = useState({
    status: '',
    msg: '',
  });

  const reset = async (obj) => {
    dispatch(setLoading(true));
    let payload = {
      password: obj.password,
      token: paramsFromUrl.verificationToken,
    };
    const response = await appapi.post(`auth/resetPassword`, payload);
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        // showmessage(data.message);
        // navigate('/login');
        setMessage({
          status: 'success',
          msg: "Your password has been successfully changed. Please click the button below to return to the login page.",
        });

      } else {
        showmessage(data.message, 'error');
      }
      dispatch(setLoading(false));
    } else {
      dispatch(setLoading(false));
      // showmessage(`Something Went Wrong!`, 2000, 'error')
    }
  };

  /**
   * @returns Redirect to initial page which is login
   */
  const onClickLoginRoute = () => navigate(`/login`);

  const handleVerificationToken = async () => {
    dispatch(setLoading(true));
    const response = await appapi.get(`auth/verifyToken/${paramsFromUrl.verificationToken}`);
    if (response.ok) {
      const data = response.data;
      if(data.status == '7400') {
        
      } else {
        setMessage({
          status: 'failed',
          msg: data.message,
        });
      }
      dispatch(setLoading(false));
      
    } else {
      dispatch(setLoading(false));
      // showmessage(`Something Went Wrong!`, 2000, 'error')
    }
  };

  useEffect(() => {
    handleVerificationToken();
  }, []);

  const ResetForm = () => {
    return (
      <>
        <Typography
          className="fw-bold ff-Roboto createHeading"
          color={theme.palette.primary.main}
        >
          {' '}
          Reset your Password{' '}
        </Typography>
        <Formik
          innerRef={formRef}
          enableReinitialize={true}
          initialValues={{
            password: data?.password || '',
            reConfirmPassword: data?.reConfirmPassword,
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => reset(values)}
        >
          {({ handleSubmit, values, handleChange, errors, touched, handleBlur, isValid, dirty }) => (
            <Form
              style={{ minHeight: '484px' }}
              noValidate
              autoComplete="off"
            >
              <Stack
                flex={1}
                className="mt-9"
              >
                <FormTextField
                  label="Password"
                  name="password"
                  type="password"
                  sx={{ mb: 0 }}
                  visibility={visibility1}
                  setVisibility={(val) => setVisibility1(val)}
                />
              </Stack>
              <Stack
                flex={1}
                className="mt-9"
              >
                <FormTextField
                  label="Retype Password"
                  name="reConfirmPassword"
                  type="password"
                  sx={{ mb: 0 }}
                  visibility={visibility2}
                  setVisibility={(val) => setVisibility2(val)}
                />
              </Stack>
              <Button
                sx={{
                  ...buttonStyle1,
                  marginBottom: '0',
                  width: '100%',
                  backgroundColor: theme.palette.primary.light,
                  '&:hover': {
                    backgroundColor: theme.palette.primary.dark,
                  },
                  color: theme.palette.background.main,
                }}
                disabled={!(dirty && isValid)}
                type="submit"
              >
                Reset
              </Button>
            </Form>
          )}
        </Formik>
      </>
    );
  };

  return (
    <div
      className="resetConfirmContainer"
      style={{
        padding: isMobile ? '16px' : '0',
        minHeight: isMobile ? 'auto' : '100vh',
      }}
    >
        <Stack
          style={{ maxWidth: '1368px', margin: 'auto' }}
          direction="row"
          justifyContent="space-between"
        >
          <Stack
            className="leftStack"
            style={{ width: '100%' }}
          >
            <Stack className="formSubmittedStyle mt-28">
              <Stack direction="row" justifyContent={'center'}>
                {/* <Typography
                  color={theme.palette.primary.light}
                  className="fw-bold ff-Roboto"
                  style={{ fontSize: '54px' }}
                >
                  Carbon
                </Typography>
                <Typography
                  color={theme.palette.secondary.main}
                  className="fw-bold ff-Roboto"
                  style={{ fontSize: '54px', marginLeft: '10px' }}
                >
                  Wallet 
                </Typography> */}
                <img src={Logo} className='w-[240px]' />
              </Stack>
              {Boolean(message.status)? (
                <div >
                  <Stack>
                    <Typography
                      className="fw-bold ff-Roboto createHeading !mt-8 !mb-3"
                      color={theme.palette.primary.light}
                    >
                      {' '}
                      {message.status ? (message.status === 'success' ? 'Successful!' : 'Failed!') : ''}{' '}
                    </Typography>
                    <Typography
                      className="fs-12 ff-Roboto fw-regular"
                      color={theme.palette.text.primary.main}
                      style={{ marginBottom: '6px' }}
                    >
                      {message.msg}
                    </Typography>
                    <Button
                      sx={{
                        ...buttonStyle1,
                        backgroundColor: theme.palette.primary.light,
                        '&:hover': {
                          backgroundColor: theme.palette.primary.dark,
                        },
                        color: theme.palette.background.main,
                        textTransform: 'capitalize',
                        marginBottom: '0',
                      }}
                      onClick={onClickLoginRoute}
                      type="submit"
                    >
                      Go Back To Login
                    </Button>
                  </Stack>
                </div>
              ) : (
                <div style={{ marginTop: '5.2083333333333vh' }}>{ResetForm()}</div>
              )}
            </Stack>
          </Stack>
        </Stack>
    </div>
  );
}
